import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useNavigate } from 'react-router-dom';

import BackArrowIcon from '../../../../assets/svg/BackArrowIcon';
import * as routing from '../../../../constants/Routing';
import { useRetrieveVehicle } from '../../hooks/useRetrieveVehicle';
import { AnalyticsTabs } from './AnalyticsTabs';

export const AnalyticsHeader = () => {
  const navigate = useNavigate();
  const { data: vehicleDetails } = useRetrieveVehicle();

  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      alignItems="center"
      gap="8px"
      style={{
        padding: `0 20px`,
      }}
    >
      <BackArrowIcon
        style={{
          color: RoutalPalette.white,
          height: `28px`,
          width: `28px`,
          fontSize: `25px`,
          cursor: `pointer`,
        }}
        onClick={() => navigate(routing.PRIVATE_ROUTES.ROOT)}
      />

      <AnalyticsTabs units={vehicleDetails?.project.units} />
    </Grid>
  );
};
